import { Roles } from '../../types/enums'
import jwtDecode from 'jwt-decode'

type jwtContent = {
  exp: number
  scope: string[]
}

export const isJwtExpired = (jwt: string) => {
  if (!jwt) return true

  const jwtDecoded = jwtDecode(jwt) as jwtContent

  if (jwtDecoded) {
    return jwtDecoded.exp - Math.floor(Date.now() / 1000) < 0
  }

  return false
}

export const getJwtScopes = (jwt: string): null | Roles[] => {
  if (!jwt) return null

  const jwtDecoded = jwtDecode(jwt) as jwtContent

  if (jwtDecoded?.scope?.length > 0) {
    return jwtDecoded.scope as Roles[]
  }

  return null
}
